var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-badge',{attrs:{"value":_vm.haveNewNotification,"color":"red","dot":"","overlap":"","offset-x":"18","offset-y":"18"}},[_c('v-btn',{attrs:{"aria-label":"go to my notifications","icon":"","to":`/notifications?back_to=${_vm.backTo}`}},[_c('v-icon',[_vm._v(_vm._s(_vm.mdiBellOutline))])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }